(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fbfy-display-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fbfy-display-filter')) {
    customElements.define('fbfy-display-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.select = this.querySelector('[data-display-family]');
        this.select.value = this.constructor.selectedFamily || '';
        this.select.addEventListener('change', () => this.update(), {signal:this.controller.signal});
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.cards = Array.from(this.closest('.collection__results').querySelectorAll('[data-display-family-card]'));
          if (!this.cards.length) return;
          this.hidden = false;
          this.update();
        });
      }
      update() {
        if (!this.cards) return;
        this.constructor.selectedFamily = this.select.value;
        let visible = 0;
        this.cards.forEach(card => {
          card.hidden = this.select.value !== '' && card.dataset.displayFamilyCard !== this.select.value;
          if (!card.hidden) visible++;
        });
        this.querySelector('[data-display-count]').textContent = visible + ' / ' + this.cards.length + ' ' + this.dataset.resultLabel;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fbfy-product-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fbfy-product-addons')) {
    class FbfyProductAddons extends HTMLElement {
      connectedCallback() {
        customElements.whenDefined('product-form').then(() => {
          if (!this.isConnected || this.controller || !('FormDataEvent' in window)) return;
          this.form = document.getElementById(this.dataset.formId);
          if (!this.form) return;
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.money = new Intl.NumberFormat(this.dataset.locale || 'nl-NL', { style:'currency', currency:this.dataset.currency || 'EUR' });
          this.form.addEventListener('formdata', event => this.buildItems(event.formData), options);
          this.form.addEventListener('variant:change', event => {
            if (event.detail.variant) this.dataset.mainPrice = event.detail.variant.price;
            this.update();
          }, options);
          this.form.addEventListener('variant:add', () => {
            this.querySelectorAll('[data-addon-toggle]').forEach(input => { input.checked = false; });
            this.update();
          }, options);
          document.addEventListener('change', event => {
            if (this.contains(event.target) || event.target.form === this.form) this.update();
          }, options);
          document.addEventListener('input', event => {
            if (event.target.form === this.form && event.target.name === 'quantity') this.update();
          }, options);
          this.hidden = false;
          this.update();
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.form?.classList.remove('fbfy-has-addons');
      }
      selected() {
        return Array.from(this.querySelectorAll('[data-addon]')).filter(row => row.querySelector('[data-addon-toggle]').checked);
      }
      update() {
        this.querySelectorAll('[data-addon]').forEach(row => {
          const option = row.querySelector('[data-addon-variant]')?.selectedOptions[0];
          if (option) {
            row.dataset.variant = option.value;
            row.dataset.price = option.dataset.price;
            row.querySelector('[data-addon-price]').textContent = this.money.format(Number(option.dataset.price) / 100);
          }
        });
        const selected = this.selected();
        const extras = selected.reduce((sum, row) => sum + Number(row.dataset.price), 0);
        this.querySelector('[data-addon-summary]').hidden = selected.length === 0;
        this.querySelector('[data-extras-total]').textContent = this.money.format(extras / 100);
        if (this.dataset.mode === 'accessories-only') {
          this.querySelector('[data-addon-main-id]').value = selected[0]?.dataset.variant || '';
          this.querySelector('[data-addon-submit]').disabled = selected.length === 0;
        } else {
          const quantity = Math.max(1, Number(this.form.elements.namedItem('quantity')?.value) || 1);
          this.querySelector('[data-order-total]').textContent = this.money.format((Number(this.dataset.mainPrice) * quantity + extras) / 100);
          this.form.classList.toggle('fbfy-has-addons', selected.length > 0);
          this.querySelector('[data-checkout-note]').hidden = selected.length === 0;
        }
      }
      buildItems(data) {
        const selected = this.selected();
        if (selected.length === 0) return;
        const standalone = this.dataset.mode === 'accessories-only';
        const mainId = data.get('id');
        let offset = 0;
        const existingIndexes = Array.from(data.keys()).map(key => key.match(/^items\[(\d+)\]/)).filter(Boolean).map(match => Number(match[1]));
        if (existingIndexes.length > 0) {
          offset = Math.max(...existingIndexes) + 1;
        } else {
          for (const [key, value] of Array.from(data.entries())) {
            if (['id','quantity','selling_plan'].includes(key) || /^properties\[/.test(key)) {
              if (!standalone) {
                const itemKey = key.startsWith('properties[') ? 'items[0][properties]' + key.slice(10) : 'items[0][' + key + ']';
                data.append(itemKey, value);
              }
              data.delete(key);
            }
          }
          if (!standalone) {
            if (!data.has('items[0][quantity]')) data.set('items[0][quantity]', '1');
            offset = 1;
          }
        }
        for (const row of selected) {
          if (!standalone && row.dataset.variant === mainId) continue;
          data.append('items[' + offset + '][id]', row.dataset.variant);
          data.append('items[' + offset + '][quantity]', '1');
          offset += 1;
        }
      }
    }
    customElements.define('fbfy-product-addons', FbfyProductAddons);
  }
  } catch(e) { console.error(e); }
})();

})();
